/**
 * Przewijanie karuzeli materacy palcem.
 *
 * Panel konfiguratora przewija perfect-scrollbar, ktory podpina sie pod
 * `touchstart`/`touchmove` na `.drawer__scroll` i przy przewijaniu wola
 * `preventDefault()`. Zdarzenia z karuzeli materacy bąbelkują do niego, wiec
 * biblioteka zjadala POZIOMY gest i natywny `overflow-x` karuzeli nie ruszal
 * (zgloszenie Patryka 4 wrz 2026, iPhone).
 *
 * Rozstrzygamy os przy pierwszym realnym ruchu palca:
 *   poziomo -> zatrzymujemy zdarzenie w fazie przechwytywania, zanim dojdzie do
 *              perfect-scrollbar; przegladarka przewija karuzele sama,
 *   pionowo -> puszczamy dalej, zeby panel przewijal sie jak dotad.
 *
 * Nie wolamy `preventDefault()` - przewijanie ma zostac natywne razem ze
 * `scroll-snap` i wytracaniem predkosci na iOS.
 */
if (!window.__cossyMattressCarouselTouch) {
  window.__cossyMattressCarouselTouch = true;

  const CAROUSEL = "[data-mattress-carousel]";
  const THRESHOLD = 4; /* px - ponizej tego gest jest jeszcze nierozstrzygniety */

  let axis = null;
  let startX = 0;
  let startY = 0;

  const carouselFrom = (event) => {
    const node = event.target;
    return node && node.closest ? node.closest(CAROUSEL) : null;
  };

  document.addEventListener(
    "touchstart",
    (event) => {
      axis = null;
      if (!carouselFrom(event) || !event.touches.length) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    "touchmove",
    (event) => {
      if (!carouselFrom(event) || !event.touches.length) return;

      if (axis === null) {
        const dx = Math.abs(event.touches[0].clientX - startX);
        const dy = Math.abs(event.touches[0].clientY - startY);
        if (dx < THRESHOLD && dy < THRESHOLD) return;
        axis = dx > dy ? "x" : "y";
      }

      if (axis === "x") event.stopPropagation();
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    "touchend",
    () => {
      axis = null;
    },
    { passive: true, capture: true }
  );
}

/**
 * Karuzela materacy na DESKTOPIE.
 *
 * Przewijanie bylo tu wylacznie natywne, a natywnego wejscia na desktopie
 * praktycznie nie ma: pasek przewijania jest schowany (`scrollbar-width: none`
 * w `section-product-configurator.css`), kolko myszy daje `deltaY`, ktore
 * perfect-scrollbar panelu zabiera dla siebie (`preventDefault`), a `deltaX`
 * ma tylko gladzik. Mysz nie miala wiec CZYM przewinac - karuzela pokazywala
 * dwie karty i skrawek trzeciej i na tym sie konczyla (zgloszenie Mateusza,
 * Chrome i Brave).
 *
 * Dokladamy trzy wejscia: strzalki, przeciaganie mysza i kolko w POZIOMIE.
 * Pionowe kolko zostaje nietkniete - ma dalej przewijac panel konfiguratora.
 *
 * Wszystko dziala przez delegacje na `document`, bo przebudowa sekcji
 * (`reloadProductSection`) podmienia zawartosc szuflady przez `innerHTML`
 * i kazde podpiecie do konkretnego wezla by wtedy przepadlo.
 */
if (!window.__cossyMattressCarouselDesktop) {
  window.__cossyMattressCarouselDesktop = true;

  const CAROUSEL = "[data-mattress-carousel]";
  const SLIDE = ".product-configurator__mattress-slide";
  const PROG_PRZECIAGNIECIA = 5; /* px - ponizej tego to jeszcze klikniecie */

  const karuzelaZ = (wezel) =>
    wezel && wezel.closest ? wezel.closest(CAROUSEL) : null;

  /* Strzalki tylko tam, gdzie jest kursor. Na dotyku gest palcem juz dziala
     i dwa okragle przyciski na kartach byly by tylko zaslona. */
  const kursorPrecyzyjny = () =>
    window.matchMedia("(min-width: 768px) and (hover: hover) and (pointer: fine)")
      .matches;

  const wciecie = (kar) => {
    const styl = getComputedStyle(kar);
    return parseFloat(styl.scrollPaddingLeft) || parseFloat(styl.paddingLeft) || 0;
  };

  const widoczneSlajdy = (kar) =>
    Array.prototype.slice
      .call(kar.querySelectorAll(SLIDE))
      .filter((s) => s.offsetParent !== null);

  function odswiezStrzalki(kar) {
    const okno = kar.closest("[data-mattress-viewport]");
    if (!okno) return;

    const wstecz = okno.querySelector("[data-mattress-prev]");
    const naprzod = okno.querySelector("[data-mattress-next]");
    if (!wstecz || !naprzod) return;

    const zapas = kar.scrollWidth - kar.clientWidth;
    const pokaz = kursorPrecyzyjny() && zapas > 1;

    wstecz.hidden = !pokaz;
    naprzod.hidden = !pokaz;
    if (!pokaz) return;

    wstecz.disabled = kar.scrollLeft <= 1;
    naprzod.disabled = kar.scrollLeft >= zapas - 1;
  }

  const odswiezWszystkie = () =>
    document.querySelectorAll(CAROUSEL).forEach(odswiezStrzalki);

  /* Wlasna animacja zamiast `behavior: "smooth"`. Przewijanie plynne w tej
     karuzeli po prostu NIE dziala - `scrollBy({ behavior: "smooth" })` zostawial
     `scrollLeft` na zerze, takze po wylaczeniu zatrzasku (zmierzone w panelu
     konfiguratora, Chrome). Ten sam skok zadany wprost (`scrollBy({ left })`)
     wykonuje sie co do piksela, wiec przejazd skladamy z takich skokow.
     Zatrzask na czas przejazdu wylaczamy, bo inaczej sciagalby karuzele po
     kazdej klatce; cel i tak lezy dokladnie na punkcie zatrzasku. */
  const CZAS_PRZEJAZDU = 260; /* ms */
  let przejazd = null;
  let straznik = null;

  /* Reka usera ma pierwszenstwo przed animacja strzalki. */
  const przerwijPrzejazd = () => {
    if (przejazd) cancelAnimationFrame(przejazd);
    if (straznik) clearTimeout(straznik);
    przejazd = null;
    straznik = null;
  };

  function animujDo(kar, cel) {
    przerwijPrzejazd();

    const start = kar.scrollLeft;
    const droga = cel - start;
    if (!droga) return;

    const poczatek = performance.now();

    kar.style.scrollSnapType = "none";

    const dojedz = () => {
      przerwijPrzejazd();
      kar.scrollLeft = cel;
      kar.style.removeProperty("scroll-snap-type");
      odswiezStrzalki(kar);
    };

    /* Zapadka. `requestAnimationFrame` nie chodzi w karcie odlozonej w tlo,
       a bez niej karuzela zostalaby w pol drogi z wylaczonym zatrzaskiem. */
    straznik = window.setTimeout(dojedz, CZAS_PRZEJAZDU + 200);

    const klatka = (teraz) => {
      const t = Math.min(1, (teraz - poczatek) / CZAS_PRZEJAZDU);

      if (t >= 1) {
        dojedz();
        return;
      }

      /* ease-out: szybko rusza, miekko dojezdza */
      kar.scrollLeft = start + droga * (1 - Math.pow(1 - t, 3));
      przejazd = requestAnimationFrame(klatka);
    };

    przejazd = requestAnimationFrame(klatka);
  }

  function przesun(kar, kierunek) {
    const slajdy = widoczneSlajdy(kar);
    if (!slajdy.length) return;

    const lewa = kar.getBoundingClientRect().left + wciecie(kar);
    const cel =
      kierunek > 0
        ? slajdy.find((s) => s.getBoundingClientRect().left > lewa + 1)
        : slajdy
            .slice()
            .reverse()
            .find((s) => s.getBoundingClientRect().left < lewa - 1);

    if (!cel) return;

    const zapas = kar.scrollWidth - kar.clientWidth;
    const docelowy = kar.scrollLeft + (cel.getBoundingClientRect().left - lewa);

    animujDo(kar, Math.max(0, Math.min(zapas, docelowy)));
  }

  /* Faza PRZECHWYTYWANIA, nie bąbelkowanie: drawer.js zatrzymuje klikniecia na
     `.drawer__content` (`this.content.addEventListener("click", e => e.stopPropagation())`),
     zeby klik w srodku szuflady jej nie zamykal - do `document` nie dochodzi
     wiec nic i strzalki przy pierwszym podejsciu nie robily zupelnie nic. */
  document.addEventListener(
    "click",
    (event) => {
      const wstecz = event.target.closest("[data-mattress-prev]");
      const naprzod = event.target.closest("[data-mattress-next]");
      if (!wstecz && !naprzod) return;

      const okno = (wstecz || naprzod).closest("[data-mattress-viewport]");
      const kar = okno && okno.querySelector(CAROUSEL);
      if (!kar) return;

      event.preventDefault();
      przesun(kar, wstecz ? -1 : 1);
    },
    true
  );

  /* Kolko. `scroll-snap-type: x mandatory` sciaga karuzele z powrotem po KAZDEJ
     zmianie `scrollLeft`, wiec drobne skoki kolka nie ruszylyby jej z miejsca -
     na czas gestu zatrzask wylaczamy i wlaczamy po chwili ciszy.
     Faza przechwytywania, bo inaczej zdarzenie dochodzi wpierw do
     perfect-scrollbar panelu. */
  let zatrzaskTimer = null;

  const wylaczZatrzask = (kar) => {
    kar.style.scrollSnapType = "none";
    if (zatrzaskTimer) clearTimeout(zatrzaskTimer);
    zatrzaskTimer = window.setTimeout(() => {
      kar.style.removeProperty("scroll-snap-type");
      zatrzaskTimer = null;
    }, 160);
  };

  document.addEventListener(
    "wheel",
    (event) => {
      const kar = karuzelaZ(event.target);
      if (!kar) return;

      /* Gest pionowy nalezy do panelu - karuzela go NIE przechwytuje. */
      const poziom =
        Math.abs(event.deltaX) > Math.abs(event.deltaY)
          ? event.deltaX
          : event.shiftKey
            ? event.deltaY
            : 0;

      if (!poziom) return;

      event.preventDefault();
      event.stopPropagation();
      przerwijPrzejazd();
      wylaczZatrzask(kar);
      kar.scrollLeft += poziom;
      odswiezStrzalki(kar);
    },
    { capture: true, passive: false }
  );

  /* Przeciaganie mysza. Karta materaca jest ETYKIETA, wiec nie da sie po prostu
     pominac klikniec w etykiety - trzeba puscic gest i dopiero na koncu zjesc
     `click`, gdy palec/kursor faktycznie przejechal kawalek. Inaczej kazde
     przeciagniecie wybieraloby materac, nad ktorym kursor zostal puszczony. */
  let ciag = null;

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.pointerType !== "mouse" || event.button !== 0) return;

      const kar = karuzelaZ(event.target);
      if (!kar || kar.scrollWidth - kar.clientWidth <= 1) return;
      if (event.target.closest("[data-mattress-prev], [data-mattress-next]")) return;

      przerwijPrzejazd();
      ciag = { kar, x: event.clientX, start: kar.scrollLeft, ruszyl: false };
    },
    true
  );

  document.addEventListener(
    "pointermove",
    (event) => {
      if (!ciag) return;

      const dx = event.clientX - ciag.x;

      if (!ciag.ruszyl) {
        if (Math.abs(dx) < PROG_PRZECIAGNIECIA) return;
        ciag.ruszyl = true;
        ciag.kar.style.scrollSnapType = "none";
        ciag.kar.classList.add("is-dragging");
      }

      event.preventDefault();
      ciag.kar.scrollLeft = ciag.start - dx;
      odswiezStrzalki(ciag.kar);
    },
    { passive: false }
  );

  const koniecCiagu = () => {
    if (!ciag) return;

    const { kar, ruszyl } = ciag;
    ciag = null;

    if (!ruszyl) return;

    kar.style.removeProperty("scroll-snap-type");
    kar.classList.remove("is-dragging");

    /* Klikniecie przychodzi zaraz po `pointerup` - lapiemy dokladnie to jedno
       i tylko jesli w ogole przyjdzie (stad zdjecie po chwili). */
    const zjedz = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
    };

    document.addEventListener("click", zjedz, { capture: true, once: true });
    window.setTimeout(
      () => document.removeEventListener("click", zjedz, { capture: true }),
      0
    );
  };

  document.addEventListener("pointerup", koniecCiagu);
  document.addEventListener("pointercancel", koniecCiagu);

  document.addEventListener(
    "scroll",
    (event) => {
      const kar = event.target;
      if (kar && kar.matches && kar.matches(CAROUSEL)) odswiezStrzalki(kar);
    },
    true
  );

  /* Filtr rozmiaru chowa karty przez `style="display:none"`, a przebudowa
     sekcji podmienia cala zawartosc szuflady - jedno i drugie zmienia zapas
     przewijania, nie ruszajac rozmiaru samej karuzeli, wiec `ResizeObserver`
     by tego nie zlapal. */
  let czekaNaKlatke = false;
  const obserwator = new MutationObserver(() => {
    if (czekaNaKlatke) return;
    czekaNaKlatke = true;
    requestAnimationFrame(() => {
      czekaNaKlatke = false;
      odswiezWszystkie();
    });
  });

  const start = () => {
    odswiezWszystkie();
    obserwator.observe(document.body, {
      attributeFilter: ["style"],
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  /* ------------------------------------------------------------------
     DOJAZD DO WYBRANEGO MATERACA

     Zgloszenie 7.09.2026: "wybralem materac i nie przewija mi sie do niego".
     Karty sa szersze niz kadr, wiec klikniecie w te wystajaca z prawej
     zaznaczalo ja, ale zostawiala sie przycieta - kupujacy widzial ramke
     wyboru na czyms, czego nie widzi w calosci.

     Przewijamy TYLKO gdy karta faktycznie nie miesci sie w kadrze. Bezwarunkowy
     dojazd szarpalby widokiem przy kazdym kliknieciu w karte juz widoczna.
     Zapas rowny wcieciu karuzeli, zeby karta nie kleila sie do krawedzi.
  ------------------------------------------------------------------ */
  const dojedzDoWybranego = (kar, slajd, natychmiast) => {
    if (!kar || !slajd) return;

    const kadr = kar.getBoundingClientRect();
    const karta = slajd.getBoundingClientRect();
    const zapas = wciecie(kar);

    let delta = 0;
    if (karta.right > kadr.right - zapas) {
      delta = karta.right - kadr.right + zapas;
    } else if (karta.left < kadr.left + zapas) {
      delta = karta.left - kadr.left - zapas;
    }
    if (!delta) return;

    const cel = Math.max(
      0,
      Math.min(kar.scrollLeft + delta, kar.scrollWidth - kar.clientWidth)
    );
    if (natychmiast) {
      kar.scrollLeft = cel;
      odswiezStrzalki(kar);
      return;
    }
    animujDo(kar, cel);
  };

  /* Dojazd do slajdu, ktory ma zaznaczone pole - uzywany takze PO
     przerenderowaniu kroku. Wybor materaca przelicza cene i podmienia sekcje,
     wiec swiezo zbudowana karuzela wraca na scrollLeft 0 i wybrana karta
     znow jest poza kadrem. Sam nasluch `change` tego nie lapie: element,
     na ktorym sie odpalil, juz nie istnieje. */
  const dojedzDoZaznaczonego = (kar, natychmiast) => {
    if (!kar || !kar.clientWidth) return;
    const pole = kar.querySelector("input:checked");
    const slajd = pole && pole.closest(SLIDE);
    if (slajd) dojedzDoWybranego(kar, slajd, natychmiast);
  };

  const dojedzWszedzie = (natychmiast) => {
    document.querySelectorAll(CAROUSEL).forEach((kar) =>
      dojedzDoZaznaczonego(kar, natychmiast)
    );
  };

  document.addEventListener(
    "change",
    (event) => {
      const kar = karuzelaZ(event.target);
      if (!kar) return;
      const slajd = event.target.closest(SLIDE);
      if (slajd) dojedzDoWybranego(kar, slajd);

      /* Drugie podejscie po przerenderowaniu. 350 ms to zapas na podmiane
         sekcji; gdy nic sie nie przerenderowalo, karta jest juz w kadrze
         i `dojedzDoWybranego` nic nie robi - warunek widocznosci chroni
         przed drugim, zbednym przejazdem. */
      setTimeout(() => dojedzWszedzie(true), 350);
    },
    true
  );

  window.addEventListener("drawerOpen", () => {
    odswiezWszystkie();
    dojedzWszedzie(true);
  });
  window.addEventListener("drawerResize", odswiezWszystkie);
  window.addEventListener("resize", odswiezWszystkie);
}
